import ReducerRegistry from '../base/redux/ReducerRegistry';
import { UPDATE_BREAKOUT_ROOMS, _RESET_BREAKOUT_ROOMS, _SET_BREAKOUT_ROOMS_TRANSITION, _UPDATE_ROOM_COUNTER } from './actionTypes';
import { FEATURE_KEY } from './constants';
const DEFAULT_STATE = {
    rooms: {},
    roomCounter: 0,
    userContextCache: {},
    inTransition: false
};
/**
 * Listen for actions for the breakout-rooms feature.
 */
ReducerRegistry.register(FEATURE_KEY, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case _UPDATE_ROOM_COUNTER:
            return {
                ...state,
                roomCounter: action.roomCounter
            };
        case UPDATE_BREAKOUT_ROOMS: {
            const { roomCounter, rooms, userContextCache } = action;
            return {
                ...state,
                roomCounter,
                rooms,
                userContextCache: userContextCache || state.userContextCache
            };
        }
        case _SET_BREAKOUT_ROOMS_TRANSITION: {
            return {
                ...state,
                inTransition: Boolean(action.inTransition)
            };
        }
        case _RESET_BREAKOUT_ROOMS: {
            return {
                ...DEFAULT_STATE,
                // Preserve the transition flag across the reset performed while
                // switching rooms, otherwise the spurious notifications would not
                // be muted.
                inTransition: state.inTransition
            };
        }
    }
    return state;
});
